module.exports = __webpack_public_path__ + "static/media/bible.a1c27635.svg";